import type { DeepString } from "@/lib/i18n";

/**
 * CEventsCalendar — polskie tłumaczenia (Kalendarz wydarzeń — lista + wydarzenie).
 *
 * `formatDate(iso)` — pełny format daty w dopełniaczu ("13 maja 2026").
 * `monthName(m)` — nazwa miesiąca (1-12) w mianowniku dla selecta filtra.
 */
export const pl = {
  emptyData: "Brak danych do wyświetlenia.",
  emptyList: "Brak wydarzeń do wyświetlenia.",
  emptyFiltered: "Brak wydarzeń dla wybranego okresu.",
  readMore: "Zobacz ->",
  backToList: "<- Wróć do listy",
  filtersLegend: "Wybierz datę wydarzenia",
  allYears: "Rok",
  allMonths: "Miesiąc",
  resetFilter: "Wyczyść filtr",
  gallery: "Galeria",
  /** `monthName(5)` -> "maj". */
  monthName: (m: number): string => {
    const months = [
      "styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec",
      "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień",
    ];
    return months[m - 1] ?? String(m);
  },
  /** `formatDate("2026-05-13")` -> "13 maja 2026". */
  formatDate: (iso: string): string => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    if (!m) return iso;
    const months = [
      "stycznia", "lutego", "marca", "kwietnia", "maja", "czerwca",
      "lipca", "sierpnia", "września", "października", "listopada", "grudnia",
    ];
    const month = parseInt(m[2], 10) - 1;
    if (month < 0 || month > 11) return iso;
    return `${parseInt(m[3], 10)} ${months[month]} ${m[1]}`;
  },
} as const;

export type CEventsCalendarTranslations = DeepString<typeof pl>;
